import * as React from "react";

import { faArrowRight } from "@fortawesome/sharp-regular-svg-icons/faArrowRight";
import { faExternalLink } from "@fortawesome/sharp-regular-svg-icons/faExternalLink";
import clsx from "clsx";

import { getLinkProps } from "~utils/link_utils/getLinkProps";

import { IconFontAwesome } from "~components/IconFontAwesome";
import { Link } from "~components/Link";
import { Typography } from "~components/Typography";

import * as styles from "~sections/Nav/desktop/styles.css";

import type { StoryblokFieldLink } from "~types/storyblok.types";

interface SubListItemProps {
  title: string;
  link: StoryblokFieldLink;
}

export const SubListItem = React.forwardRef<
  HTMLAnchorElement,
  SubListItemProps
>(({ title, link }, forwardedRef) => {
  const { linkType } = getLinkProps(link) || {};
  const isInternalLink = linkType === "internalLink";

  return (
    <Link
      className={clsx(styles.subListItemLink)}
      link={link}
      ref={forwardedRef}
    >
      <Typography
        className={styles.subListItemHeading}
        textAppearance="body_sm"
        fontWeight="bold"
        as="span"
      >
        {title}
      </Typography>
      <IconFontAwesome
        icon={faArrowRight}
        size="xs"
        className={clsx(
          styles.subListItemIcon,
          isInternalLink
            ? styles.listItemIconVisible
            : styles.listItemIconHidden
        )}
      />
      <IconFontAwesome
        icon={faExternalLink}
        size="xs"
        className={clsx(
          styles.subListItemIcon,
          isInternalLink
            ? styles.listItemIconHidden
            : styles.listItemIconVisible
        )}
      />
    </Link>
  );
});
